import { MenuItem } from '../../models';

/** holds items for admin dropdown used in navbar */
export const ADMIN_LIST: MenuItem[] = [
  { title: 'Student Roster', link: '/admin/student-roster' },
  { title: 'Learning Apps', link: '/admin/learning-apps' },
  { title: 'Learning App Status', link: '/admin/learning-app-status' },
];
